import script from "./threat-distribution-card.vue?vue&type=script&lang=ts&setup=true"
export * from "./threat-distribution-card.vue?vue&type=script&lang=ts&setup=true"

import "./threat-distribution-card.vue?vue&type=style&index=0&id=fe721432&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe721432"]])

export default __exports__